import { setLanguage } from '@/utils/cookies'

const state = {
    language: 'en',
    is_fold:true
}
const mutations = {
    setLanguages (state: any, language: string) {
       
        
        state.language = language
        setLanguage(language)
        console.log('数据值',language);
    },
    setLsFold(state:any,data:boolean){
       state.is_fold = data
    }
}
const actions = {
    setLanguages(context: any, language: string) {
        context.commit('setLanguages', language)
    },
    setLsFold(context:any,data:boolean){
        context.commit('setLsFold', data)
     }
}
export default {
    state,
    mutations,
    actions
}